module.exports = __webpack_public_path__ + "img/will1.13182641.jpeg";